"use strict";
exports.__esModule = true;
exports.SubClientUtils = void 0;
var enums_1 = require("../enums");
var SubClientUtils = /** @class */ (function () {
    function SubClientUtils() {
    }
    SubClientUtils.IsEServiceEnabled = function (objSubClient) {
        var _a, _b;
        return !!(((_a = objSubClient === null || objSubClient === void 0 ? void 0 : objSubClient.Credentials) === null || _a === void 0 ? void 0 : _a.StateSalesTaxPassword) &&
            ((_b = objSubClient === null || objSubClient === void 0 ? void 0 : objSubClient.Credentials) === null || _b === void 0 ? void 0 : _b.StateSalesTaxUsername));
    };
    SubClientUtils.IsTourismTaxEligible = function (objSubClient) {
        return (objSubClient === null || objSubClient === void 0 ? void 0 : objSubClient.BusinessType) === enums_1.SUB_CLIENT_BUSINESS_TYPE.HOTEL;
    };
    return SubClientUtils;
}());
exports.SubClientUtils = SubClientUtils;
//# sourceMappingURL=SubClientUtils.js.map